import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../Univ.js';

function EditTemplate() {
    const { id } = useParams();
    const quillRef = useRef(null);
    const [tempData, setTempData] = useState({
        "type": '',
        "template": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${baseUrl}edit-template/${id}/`)
            .then(response => {
                setTempData({
                    temp_id: response.data.id,
                    type: response.data.type,
                    template: response.data.template,
                });
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    }, [id]);

    const handleChange = (event) => {
        setTempData({
            ...tempData,
            [event.target.name]: event.target.value
        });
    }

    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('type', tempData.type);
        _formData.append('template', tempData.template);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);

        axios.put(`${baseUrl}edit-template/${id}/`, _formData, {
            headers: {
                'content-type': 'multiple/form-data'
            }
        })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                Swal.fire({
                    title: 'Data has been updated',
                    icon: 'success',
                    timer: 3000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.href = '/add-template/';
                }, 3000);
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const handleLoad = (quill) => {
        quillRef.current = quill;
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Template</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="type" className="form-label">Type</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="type"
                                        value={tempData.type}
                                        onChange={handleChange}
                                        id="type"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="template" className="form-label">Template</label>
                                    <ReactQuill
                                        style={{ height: "200px" }}
                                        className="my-quill"
                                        tabIndex="0"
                                        onLoad={handleLoad}
                                        name="template"
                                        id="result"
                                        value={tempData.template}
                                        onChange={(value) => handleChange({ target: { name: 'template', value } })}
                                        modules={{
                                            toolbar: [
                                                [{ header: [1, 2, false] }],
                                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                [
                                                    { list: 'ordered' },
                                                    { list: 'bullet' },
                                                    { indent: '-1' },
                                                    { indent: '+1' },
                                                ],
                                                ['link', 'image'],
                                                ['table'],
                                                ['clean'],
                                            ],
                                        }}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-5">
                                    <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditTemplate;
